import { Phone, MapPin } from "lucide-react";
import { LogoMark } from "./Logo";

const LINKS = [
    ["Services", "#services"],
    ["Why Us", "#why-us"],
    ["Projects", "#projects"],
    ["Reviews", "#reviews"],
    ["Request a quote", "#contact"],
];

export const Footer = () => (
    <footer data-testid="main-footer" className="border-t border-white/10 bg-[#13191E] corrugation">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-16 pb-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-10 pb-14">
                <div>
                    <div className="flex items-center gap-3">
                        <LogoMark size={40} />
                        <p className="font-display font-bold uppercase text-lg text-[#F8FAFC]">One God Roofing Ltd</p>
                    </div>
                    <p className="mt-4 text-sm text-[#94A3B8] leading-relaxed max-w-xs">
                        "Quality materials for your building." Serving Sunyani and nearby
                        areas with roofing and gutters done right.
                    </p>
                </div>

                <nav className="flex flex-col gap-3">
                    {LINKS.map(([label, href]) => (
                        <a key={href} href={href} data-testid={`footer-link-${label.toLowerCase().replace(/\s/g, "-")}`} className="text-sm text-[#94A3B8] hover:text-amber-500 transition-colors w-fit">
                            {label}
                        </a>
                    ))}
                </nav>

                <div className="flex flex-col gap-3 text-sm text-[#94A3B8]">
                    <a href="tel:+233553237357" data-testid="footer-phone-0553237357" className="flex items-center gap-2.5 hover:text-amber-500 transition-colors">
                        <Phone size={15} className="text-amber-500" /> 055 323 7357
                    </a>
                    <a href="tel:+233279912807" data-testid="footer-phone-0279912807" className="flex items-center gap-2.5 hover:text-amber-500 transition-colors">
                        <Phone size={15} className="text-amber-500" /> 027 991 2807
                    </a>
                    <p className="flex items-start gap-2.5">
                        <MapPin size={15} className="text-amber-500 shrink-0 mt-0.5" />
                        J.H. Owusu Acheampong St, Sunyani
                    </p>
                    <p className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-[#10B981] flex items-center gap-2 mt-1">
                        <span className="w-1.5 h-1.5 rounded-full bg-[#10B981]" /> Open · Closes 5 pm
                    </p>
                </div>
            </div>

            <p data-testid="footer-brand-title" className="font-display font-extrabold uppercase leading-[0.85] text-[clamp(2.6rem,10.5vw,9rem)] select-none">
                <span className="text-[#F8FAFC]">One God</span>
                <br />
                <span className="text-outline">Roofing</span>
            </p>

            <div className="border-t border-white/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
                <p className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-[#64748B]">
                    © {new Date().getFullYear()} One God Roofing Limited Company · Sunyani, Ghana
                </p>
                <p className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-[#64748B]">
                    Quality materials for your building
                </p>
            </div>
        </div>
    </footer>
);

export default Footer;
